import { formatDate } from '@angular/common';
import { Component, OnInit ,ChangeDetectorRef  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { CountryDetails } from '../CountryDetails';
import { RoamersSegment } from '../RoamersSegment';

@Component({
  selector: 'app-roamers-pack-history',
  templateUrl: './roamers-pack-history.component.html',
  styleUrls: ['./roamers-pack-history.component.scss']
})
export class RoamersPackHistoryComponent implements OnInit {

  roamerSegmentForm: FormGroup;
  private dateToString = (date: any) => `${date.year}-${date.month}-${date.day}`;

  country = []
  dataSource = []
  network = []
  VPMNCountry = []
  VPMNnetwork = []
  VPMNtadig = []
  HPMNtadig = []
  showTable: boolean;
  messageCategory = ["MessageCategory1", "MessageCategory2", "MessageCategory3"]
  vpmnCountryList: any;
  vpmnNetworkList: any;
  vpmnTadigList: any;
  submitted = false;
  callVPMNNetwork: boolean;
  

  constructor(private formBuilder: FormBuilder, private endpointsService: EndpointsService,
    private backendApiService: BackendApiService, private spinnerService: Ng4LoadingSpinnerService,private changeDetectorRefs: ChangeDetectorRef) { }

  ngOnInit() {
    this.createRoamersSegmentForm();
    this.getVPMNCountryDetails();
    //this.storeAnalytics();
    
  }

  createRoamersSegmentForm() {
    this.roamerSegmentForm = this.formBuilder.group({
      HPMNtadig: [sessionStorage.getItem('homeTadg')],
      country: [sessionStorage.getItem('homeCountryNameWithOp')],
      network: [sessionStorage.getItem('homeOp')],
      msgCatergory: ['ALL'],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      msidn: [],
      VPMNCountry: [''],
      VPMNnetwork: [''],
      VPMNtadig: [''],
    });
  }

  changeDateEvent(targetCalendarId: any) {
    targetCalendarId.toggle();
  }

  search() {
    
    this.submitted = true;
    if(this.roamerSegmentForm.invalid){
      return;
    }
    
    this.getSearch();
    this.storeAnalytics();
  }


  getSearch(){
    this.showTable = false;
    if(this.roamerSegmentForm.get('startDate').value <= this.roamerSegmentForm.get('endDate').value){
    let url = this.endpointsService.ROAMERS_PACK_HISTORY;
    // let countryData = this.roamerSegmentForm.get('country').value;
    let countryData = this.roamerSegmentForm.get('VPMNCountry').value;
    if (countryData) {
      url += "&country=" + countryData.trim()
    }
    // let networkData = this.roamerSegmentForm.get('network').value;
    let networkData = this.roamerSegmentForm.get('VPMNnetwork').value;
    if (networkData) {
      url += "&network=" + networkData
    }
    let tadigData = this.roamerSegmentForm.get('VPMNtadig').value;
    if (tadigData) {
      url += "&tadig=" + tadigData
    }
    // let msgCatergory = this.roamerSegmentForm.get('msgCatergory').value;
    // if (msgCatergory) {
    //   url += "&msgCatergory=" + msgCatergory
    // }
    let startDate = this.roamerSegmentForm.get('startDate').value;
    if (startDate) {
      url += "&startDate=" + this.dateFormate(this.roamerSegmentForm.value.startDate);
    }
    let endDate = this.roamerSegmentForm.get('endDate').value;
    if (endDate) {
      url += "&endDate=" + this.dateFormate(this.roamerSegmentForm.value.endDate);
    }
    // let msidn = this.roamerSegmentForm.get('msidn').value;
    // if (msidn) {
    //   url += "&msisdn=" + msidn
    // }
    url += "&userOrgId=" + sessionStorage.getItem('userOrgId');
    
    this.backendApiService.callToApi(url).subscribe(res => {
      if(res){
 
        this. dataSource = res['RoamersPackHistoryResponse']
      }
      
      this.showTable = true;
    });
  }
  else {
    alert("End Date cannot be less than Start Date");
    return;
  }
}

  getCountryDetails() {
    this.backendApiService.callToApi(this.endpointsService.COUNTRY_DETAILS).subscribe(res => {
      
      this.country = res;
    });
  }

  networkValues() {
    this.getNetworkDetails()
  }

  getNetworkDetails() {
    let cntry = this.roamerSegmentForm.get('country').value.split("_")[1]
    
    this.backendApiService.callToApi(this.endpointsService.NETWORK_DETAILS
      + "&country=" + cntry)
      .subscribe(res => {
        this.network = res;
      });
  }

  async getVPMNCountryDetails() {
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.vpmnCountryList = response;
    });
  }

  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === 'ALL') {
      this.roamerSegmentForm.controls.vpmnNetwork.setValue('ALL', { onlySelf: true });
    } else {
      this.getVpmnNetworkList(event.target.value).then();
    }
  }

  async getVpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.vpmnNetworkList = response;
      if (this.vpmnNetworkList && this.vpmnNetworkList.length > 0) {
        this.roamerSegmentForm.controls.VPMNnetwork.setValue(response[0].operator, { onlySelf: true });
      }
      this.getTadig();
    });
  }

  getTadig() {
    if(this.roamerSegmentForm.controls.VPMNCountry.value == '' || this.roamerSegmentForm.controls.VPMNnetwork.value == ''){
      this.vpmnTadigList = [];
      this.roamerSegmentForm.get('VPMNtadig')
          .setValue('', {onlySelf: true});
    }
    else{
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.roamerSegmentForm.get('VPMNCountry').value +
      '&operator=' + this.roamerSegmentForm.get('VPMNnetwork').value).
      subscribe(response => {
        if (response.length === 0) {
          return;
        }
        this.vpmnTadigList = response;
        this.roamerSegmentForm.get('VPMNtadig')
          .setValue(response[0].tapCode, {onlySelf: true});
      });
    }
  }

  get f() {
    return this.roamerSegmentForm.controls;
  }

  dateFormate(date) {
    return formatDate(date, 'yyyy-MM-dd HH:mm', 'en');
  }


  reset(){
    this.spinnerService.show();
    this.createRoamersSegmentForm();
    this.showTable = false;
    this.storeAnalytics1();
  }
  async storeAnalytics() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=roamers pack history' + '&operation=search';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });

  }
   storeAnalytics1() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=roamers pack history' + '&operation=reset';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });

  }


}